import React, { Fragment, PureComponent } from 'react';
import Lottie from 'react-lottie';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import * as styles from './style.css';
import UQButton from '../../../../uq-ui/components/button';
import Icon from '../../../../icons/Icon';
import LayoutComponentsLoaderProcessing from '../../../../layout/ui/components/loader-processing';
import Div100vh from '../../../../uq-ui/components/div-100';
import StickersScreensNewStickerFormat from '../../screens/new-sticker-format';
import { currentUserInfoSelector } from '../../../../../modules/auth/store/auth-user/selectors';
import { useSelector } from 'react-redux';
import { useSticker } from '../../../store/sticker-show/hooks';
import { useHistory, useParams } from 'react-router';

const bgAnimation = require('./bg-animation.json');
const bodyAnimation = require('./body-animation.json');
const wowAnimation = require('./wow-animation.json');

const mainAnimationOptions = {
  loop: true,
  autoplay: true,
  animationData: bodyAnimation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const bgAnimationOptions = {
  loop: true,
  autoplay: true,
  animationData: bgAnimation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const wowAnimationOptions = {
  loop: false,
  autoplay: true,
  animationData: wowAnimation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

class StickersComponentsCongratulations extends PureComponent {
  static defaultProps = {
    viewItPressed: () => {},
    containerStyle: {},
    showAnimation: true,
    canAddStickerItem: true,
  };

  static propTypes = {
    title: PropTypes.string,
    viewItPressed: PropTypes.func,
    containerStyle: PropTypes.any,
    showAnimation: PropTypes.Boolean,
    isMemorialTheme: PropTypes.bool,
    canAddStickerItem: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      showBalloonsAnimation: true,
      showAnimation: false,
      showLogo: true,
      showLoader: true,
    };
  }

  onShowPressed = (event) => {
    event.stopPropagation();
    event.preventDefault();
    this.props.viewItPressed();
  };

  onBalloonsAnimationFinished = () => {
    this.setState({ showBalloonsAnimation: false });
  };

  onLogoLoadSuccess = () => {
    this.setState({ showAnimation: this.props.showAnimation, showLoader: false });
  };

  onLogoLoadFailed = () => {
    this.setState({ showLogo: false, showAnimation: this.props.showAnimation, showLoader: false });
  };

  render() {
    const containerStyles = Object.assign({ minHeight: '100rvh', overflow: 'hidden' }, this.props.containerStyle);
    return (
      <Div100vh className={this.props.isMemorialTheme ? styles.container_memorial : styles.container} style={containerStyles}>
        <LayoutComponentsLoaderProcessing show={this.state.showLoader} opacity={1} />
        <div className={styles.header}>
          {this.state.showLogo && !this.props.isMemorialTheme && (
            <Icon
              onLoad={this.onLogoLoadSuccess}
              onError={this.onLogoLoadFailed}
              className={styles.profileAvatar}
              name="DefaultAvatar"
              width="90px"
              height="90px"
            />
          )}
          {this.state.showLogo && this.props.isMemorialTheme && (
            <Icon
              onLoad={this.onLogoLoadSuccess}
              onError={this.onLogoLoadFailed}
              className={styles.memorialCandle}
              name="MemorialCandle"
              width="200px"
              height="200px"
            />
          )}
          <div className={`${styles.title} font-title`} dangerouslySetInnerHTML={{ __html: this.props.title }} />
          <UQButton
            label={this.props.t('viewItBtn')}
            containerStyle={{ minWidth: 140 }}
            theme={this.props.isMemorialTheme ? 'whiteDarkText' : 'whiteBrand'}
            onPress={this.onShowPressed}
          />
        </div>
        {this.props.canAddStickerItem && <StickersScreensNewStickerFormat isCongratulationView={true} history={this.props.history} />}
        {this.state.showAnimation && (
          <Fragment>
            <div className={styles.mainAnimation}>
              <Lottie options={mainAnimationOptions} isClickToPauseDisabled={true} />
            </div>
            <div className={styles.bgAnimation}>
              <Lottie options={bgAnimationOptions} isClickToPauseDisabled={true} />
            </div>
            {this.state.showBalloonsAnimation && (
              <div className={styles.wowAnimation}>
                <Lottie
                  options={wowAnimationOptions}
                  isClickToPauseDisabled={true}
                  eventListeners={[{ eventName: 'complete', callback: this.onBalloonsAnimationFinished }]}
                />
              </div>
            )}
          </Fragment>
        )}
      </Div100vh>
    );
  }
}

export default withTranslation('cmp-congratulations')(StickersComponentsCongratulations);



// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/components/congratulations/index.jsx